import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import TextField from '@material-ui/core/TextField';
import { VIDEOS } from '../../constants.js';
import { useGlobal } from 'reactn';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DoneIcon from '@material-ui/icons/Done';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import { blackColor } from 'assets/jss/material-dashboard-react.js';
import { FUNCTION_URL } from 'constants.js';
import MaterialTable from 'material-table'
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import { EventHubConsumerClient, latestEventPosition } from '@azure/event-hubs';
// const useStyles = makeStyles(styles);
import {
    
    whiteColor,
    grayColor
} from "assets/jss/material-dashboard-react.js";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    smallAvatar: {
        display: 'flex',
        width: "25px",
        height: "25px",
    },
    smallAvatarSuccess: {
        width: "25px",
        height: "25px",
        backgroundColor: "#004F69",
    },
    orange: {
        color: theme.palette.getContrastText(blackColor),
        backgroundColor: blackColor,
    },
    cardTitleWhite: {
        color: whiteColor,
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: grayColor[1],
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    log: {
        "font-family": "Courier New",
        fontSize: 16
    },
}));

const useTableStyles = makeStyles(styles);

export default function KFW(props) {

    const classes = useStyles();
    const tableClasses = useTableStyles();
    // const [user] = useGlobal('user');
    const [eventHub] = useGlobal('eventHub')
    const [subFlag, setSubFlag] = React.useState(false)
    const [accessLogs, setAccessLogs] = React.useState([])
    var consumerClient;
    var subscription;
    const { app, isAdmin } = props
    const [columns, setColumns] = React.useState([
        { title: 'Timestamp', field: 'timestamp', filtering: false },
        { title: 'Operation', field: 'op' },
        { title: 'User Email', field: 'email' }
      ]);

    const [flags, setFlags] = React.useState({
        "boot": 1,
        "cleanup": 0,
        "networkDeployment": 0,
        "createChannel": 0,
        "joinChannel1": 0,
        "joinChannel2": 0,
        "joinChannel3": 0,
        "joinChannel4": 0,
        "joinChannel5": 0,
        "joinChannel": 0,
        "installChaincode11": 0,
        "installChaincode12": 0,
        "installChaincode13": 0,
        "installChaincode14": 0,
        "installChaincode15": 0,
        "installChaincode1": 0,
        "instantiateChaincode1": 0,
        "initialDataLoad": 0,
        "finalChecks": 0,
        "logs": "",
        "appURL": "",
        "simURL": "",

    });


    React.useEffect(() => {
        getAccessLogs(app)
        if (app.appStatus === 1) {
            eventSubscribe(app.partitionId);
        } else {
            setFlags(app.eventObject)
        }

        return (async () => {
            if (subFlag) {
                await subscription.close();
                await consumerClient.close();
            }
        });
    }, [app.appStatus]);

    const getAccessLogs = (app) => {
        fetch(FUNCTION_URL, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
    
            'Access-Control-Allow-Credentials': 'true'
          },
          body: JSON.stringify({
            "app": app,
            "operation": "getLogs"
          })
        })
          .then(data => { return data.json() })
          .then(jsondata => {
            jsondata.map(data => {
                data['timestamp'] = new Date(data.timestamp).toUTCString()
            })
            setAccessLogs(jsondata)
          });
      }

    const eventSubscribe = (partitionId) => {
        setSubFlag(true)
        const connectionString = eventHub.connectionString;
        const eventHubName = eventHub.eventHubName;
        const consumerGroup = eventHub.consumerGroup;
        consumerClient = new EventHubConsumerClient(consumerGroup, connectionString, eventHubName);

        subscription = consumerClient.subscribe(partitionId,
            {
                processEvents: async (events, context) => {

                    for (const event of events) {
                        
                        setFlags(event.body)
                    }
                },
                processError: async (err, context) => {
                    console.log(`Error : ${err}`);
                }
            },
            { startPosition: latestEventPosition }
        );
    }

    const progressUpdate = (flag) => {
        return <ListItemAvatar>
            {flag === 0 &&
                <Avatar><DoneIcon /></Avatar>
            }
            {flag === 1 &&

                <Avatar style={{ background: "#004F69" }}><i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true"></i></Avatar>
            }
            {flag === 2 &&
                <Avatar className={classes.avatar} style={{ background: "#004F69" }}>
                    <DoneIcon />
                </Avatar>
            }
        </ListItemAvatar>
    }

    const progressUpdateMinor = (flag) => {
        return <span>
            {flag === 0 &&
                <Avatar className={classes.smallAvatar}><DoneIcon /></Avatar>
            }
            {flag === 1 &&
                <Avatar className={classes.smallAvatar}>
                    <i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true">
                    </i>
                </Avatar>
            }
            {flag === 2 &&
                <Avatar className={classes.smallAvatarSuccess}>
                    <DoneIcon />
                </Avatar>
            }
        </span>
    }

    const url = () => {
        if (flags.finalChecks == 2) {
            return (
                <Card style={{ backgroundColor: "#D3D3D3" }} >
                    <CardHeader color="warning">
                        <h4 className={classes.cardTitleWhite}>URLs </h4>
                    </CardHeader>
                    <CardBody>
                        <div>
                            <p>
                                <b>Application URL :</b> <a style={{ color: "#cf022b" }} href={flags.appURL} target="_blank" rel="noopener noreferrer">{flags.appURL}</a><br />
                                <b>Simulator URL :</b> <a style={{ color: "#cf022b" }} href={flags.simURL} target="_blank" rel="noopener noreferrer">{flags.simURL}</a>
                            </p>
                        </div>

                    </CardBody>
                </Card>
            )
        }
    }

    // const formatLog = (log) => { return log.join("\n") }

    return (
        <div style={{ backgroundColor: "#0F171E" }}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <Card style={{ backgroundColor: "#D3D3D3" }} >
                        <CardHeader color="warning">
                            <h4 className={classes.cardTitleWhite}>Deployment Log</h4>
                        </CardHeader>
                        <CardBody>
                            <TextField id="req"
                                variant="outlined" multiline fullWidth
                                value={flags.logs}
                                style={{ margin: "25px 0px 0px 0px" }}
                                label="Deployment Log"
                                InputProps={{
                                    classes: {
                                        input: classes.log,
                                    },
                                }} />
                        </CardBody>
                    </Card>
                    {isAdmin ?
                        <Card style={{ backgroundColor: "#D3D3D3" }} >
                            <CardHeader color="warning">
                                <h4 className={classes.cardTitleWhite}>Access Log</h4>
                            </CardHeader>
                            <CardBody>
                                <div className={tableClasses.table}>
                                    <MaterialTable
                                        options={{
                                            filtering: true,
                                            toolbar: false,
                                            pageSize: 10,
                                            pageSizeOptions: [10],
                                            actionsColumnIndex: -1,
                                            headerStyle: {
                                                backgroundColor: '#253747',
                                                color: 'white'
                                            },
                                            rowStyle: {
                                                fontSize: 14,
                                                backgroundColor: 'primary',
                                            },
                                            backgroundColor: 'primary',
                                        }}
                                        columns={columns}
                                        data={accessLogs}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                        :
                        null
                    }
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <Card style={{ backgroundColor: "#D3D3D3" }}>
                        <CardHeader color="warning">
                            <h4 className={classes.cardTitleWhite}>Progress</h4>
                        </CardHeader>
                        <CardBody>
                            <List>
                                <ListItem button key="step1">
                                    {progressUpdate(flags.boot)}
                                    <ListItemText primary="Machine Boot up" />
                                </ListItem>
                                <Divider />
                                <ListItem button key="step01">
                                    {progressUpdate(flags.cleanup)}
                                    <ListItemText primary="Clean up" />
                                </ListItem>
                                <Divider />
                                <ListItem button key="step2">
                                    {progressUpdate(flags.networkDeployment)}
                                    <ListItemText primary="Blockchain Network Deployment" />
                                </ListItem>
                                <Divider />
                                <ListItem button key="step3">
                                    {progressUpdate(flags.createChannel)}
                                    <ListItemText primary="Create Channel" />
                                </ListItem>
                                <Divider />
                                <ListItem button key="step4">
                                    {progressUpdate(flags.joinChannel)}
                                    <ListItemText primary="Join Channel"
                                        secondary={
                                            <React.Fragment>
                                                <div className={classes.root}>
                                                    {progressUpdateMinor(flags.joinChannel1)}
                                                    {progressUpdateMinor(flags.joinChannel2)}
                                                    {progressUpdateMinor(flags.joinChannel3)}
                                                    {progressUpdateMinor(flags.joinChannel4)}
                                                    {progressUpdateMinor(flags.joinChannel5)}
                                                </div>
                                            </React.Fragment>
                                        } />
                                </ListItem>
                                <Divider />
                                <ListItem button key="step5">
                                    {progressUpdate(flags.installChaincode1)}
                                    <ListItemText primary="Install Chaincode - KFW"
                                        secondary={
                                            <React.Fragment>
                                                <div className={classes.root}>
                                                    {progressUpdateMinor(flags.installChaincode11)}
                                                    {progressUpdateMinor(flags.installChaincode12)}
                                                    {progressUpdateMinor(flags.installChaincode13)}
                                                    {progressUpdateMinor(flags.installChaincode14)}
                                                    {progressUpdateMinor(flags.installChaincode15)}
                                                </div>
                                            </React.Fragment>
                                        } />
                                </ListItem>
                                <Divider />
                                <ListItem button key="step6">
                                    {progressUpdate(flags.instantiateChaincode1)}
                                    <ListItemText primary="Instantiate Chaincode" />
                                </ListItem>
                                <Divider />
                                <ListItem button key="step7">
                                    {progressUpdate(flags.initialDataLoad)}
                                    <ListItemText primary="Initial Data Load" />
                                </ListItem>
                                <Divider />
                                <ListItem button key="step8">
                                    {progressUpdate(flags.finalChecks)}
                                    <ListItemText primary="Final Checks" />
                                </ListItem>
                            </List>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    {url()}
                    <Card style={{ backgroundColor: "#D3D3D3" }}>
                        <CardHeader color="warning">
                            <h4 className={classes.cardTitleWhite}>Sales </h4>
                        </CardHeader>
                        <CardBody>
                            <OndemandVideoIcon style={{ color: "#cf022b", margin: "0px 5px -5px 15px" }} />
                            <a target="_blank" href={VIDEOS.KFW}>
                                Video
                        </a>
                            
                        </CardBody>
                    </Card>
                    <Card style={{ backgroundColor: "#D3D3D3" }}>
                        <CardHeader color="warning">
                            <h4 className={classes.cardTitleWhite}>Application Credentials</h4>
                        </CardHeader>
                        <CardBody>
                            <div>
                                <p>
                                    <b>KFW</b><br />
                                    <b>Username:</b> KFW<br />
                                    <b>Password:</b> kfw@20$!
                                </p>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
                
            </GridContainer>
        </div>
    );

}